// DisclosureRangeType.ktを参照
const DisclosureRangeType = {
  地域包括支援センター職員のみに公開: { code: "002" },
  地域包括支援センター職員_社会福祉協議会職員のみに公開: { code: "003" },
  専門職のみに公開: { code: "001" },
};

export default DisclosureRangeType;
